<template>
  <div class="header">
    <div class="field-narrow">{{ $t('number') }}</div>
    <div class="field-medium">{{ $t('username') }}</div>
    <div class="field-medium">{{ $t('name') }}</div>
    <div class="field-narrow">{{ $t('permission') }}</div>
    <div class="field-medium">{{ $t('lastLoginTime') }}</div>
    <div class="field-medium">{{ $t('createTime') }}</div>
    <div class="field-medium">{{ $t('operation') }}</div>
  </div>
</template>

<script>
export default {
};
</script>

<style>
.header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}

.err-msg {
  width: 100vw;
  color: red;
  text-align: center;
}
</style>
